import { ss } from "@/utils/storage";
import type { UserState } from "@/typings/types";

const BASE_NAME = "userStorage";

export function defaultSetting(): UserState {
 return {
 userInfo: {
 uuid: "",
 avatar: "",
 name: "",
 username: "",
 description: "",
 isGuest: false,
 isAuthenticated: false,
 userAgent: navigator.userAgent,
 browserDigest: null,
 tier: "free",
 apiTier: "tier0",
 dataUsageConsent: false,
 phone: "",
 email: "",
 customAgents: [],
 halfSpaceUnicode: true,
 customAgentsCosts: {},
 currencyExchangeRate: 80000,
 guides: true,
 totalUnit: 0.0,
 subscriptionStartDate: "",
 subscriptionEndDate: "",
 useGeneralSystemMessage: false,
 generalSystemMessage: "",
 referralCode: "",
 totalPaidInUnit: 0,
 // NEW: Guest mode defaults
 isGuestMode: false,
 guestSessionStart: undefined,
 guestPermissions: ['view', 'read', 'browse'],
 },
 };
}

export function getLocalState(): UserState {
  const localName = `${BASE_NAME}`;
  const localSetting: UserState | undefined = ss.get(localName);
  return { ...defaultSetting(), ...localSetting };
}

export function setLocalState(setting: UserState): void {
  const localName = `${BASE_NAME}`;
  ss.set(localName, setting);
}
